import type { MatchDetails } from "./types";

// ==================================================
// MATCH DETAILS 2026/27 — MEN'S DOMESTIC
// EPCR CHALLENGE CUP
// ==================================================

export const matchDetailsEPCR: MatchDetails[] = [

  // ==================================================
  // EPCR CHALLENGE CUP 2026/27 — ROUND 1
  // ==================================================

  {
    matchKey: "dragons-vs-usap-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=CTzZ-MeApJg",
    timeline: [
      { minute: "0'", label: "Kick-off — Rodney Parade, Newport" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Rodney Parade", value: "Newport" },
    ],
  },

  {
    matchKey: "edinburgh-vs-toulon-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=0Or-r0epQcI",
    timeline: [
      { minute: "0'", label: "Kick-off — Hive Stadium, Edinburgh" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Hive Stadium", value: "Edinburgh" },
    ],
  },

  {
    matchKey: "lou-vs-sharks-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=QdJZWtbmfIQ",
    timeline: [
      { minute: "0'", label: "Kick-off — Matmut Stadium, Lyon" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Matmut Stadium", value: "Lyon" },
    ],
  },

  {
    matchKey: "black-lion-vs-ospreys-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=AdZGghabcm0",
    timeline: [
      { minute: "0'", label: "Kick-off — Avchala Stadium, Tbilisi" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Avchala Stadium", value: "Tbilisi" },
    ],
  },

  {
    matchKey: "zebre-vs-ulster-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=WhWE5dSbBdM",
    timeline: [
      { minute: "0'", label: "Kick-off — Stadio Sergio Lanfranchi, Parma" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Stadio Sergio Lanfranchi", value: "Parma" },
    ],
  },

  {
    matchKey: "scarlets-vs-newcastle-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=bs2kobj9U1E",
    timeline: [
      { minute: "0'", label: "Kick-off — Parc y Scarlets, Llanelli" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Parc y Scarlets", value: "Llanelli" },
    ],
  },

  {
    matchKey: "bayonne-vs-cheetahs-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=_pOeDC4sv3Y",
    timeline: [
      { minute: "0'", label: "Kick-off — Stade Jean Dauger, Bayonne" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Stade Jean Dauger", value: "Bayonne" },
    ],
  },

  {
    matchKey: "harlequins-vs-vannes-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=ddG2UJPzMGg",
    timeline: [
      { minute: "0'", label: "Kick-off — Twickenham Stoop, London" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Twickenham Stoop", value: "London" },
    ],
  },

  {
    matchKey: "castres-vs-benetton-epcr",
    highlightsUrl: "https://www.youtube.com/watch?v=nYe4VWpLhxo",
    timeline: [
      { minute: "0'", label: "Kick-off — Stade Pierre-Fabre, Castres" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Stade Pierre-Fabre", value: "Castres" },
    ],
  },
];